import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { AppBarProps, AppBar as RaAppBar } from 'react-admin'
import { color, xxllncColor } from './themes'
import { UserMenu } from './UserMenu'

const AppBar: FC<AppBarProps> = (props) => (
  <StyledAppBar
    className={classes.root}
    container='div'
    elevation={1}
    userMenu={<UserMenu />}
    {...props}
  >
    <div className={classes.headerContainer}>
      <h1 className={classes.appLogo}>
        <span className={classes.vignet} aria-hidden="true">Ce</span>
        <span className={classes.appName}>Certificaten</span>
      </h1>
    </div>

    <span className={classes.spacer} />
  </StyledAppBar>
)

const PREFIX = 'xxllncAppBar'

const classes = {
  root: `${PREFIX}-root`,
  spacer: `${PREFIX}-spacer`,
  headerContainer: `${PREFIX}-headerContainer`,
  appLogo: `${PREFIX}-appLogo`,
  appName: `${PREFIX}-appName`,
  vignet: `${PREFIX}-vignet`,
}

const StyledAppBar = styled(RaAppBar)(({ theme }) => ({
  [`&.${classes.root}`]: {
    color: color.white,
  },
  ['& .RaAppBar-toolbar']: {
    height: theme.spacing(4),
  },
  [`& .${classes.spacer}`]: {
    flex: 1,
  },
  [`& .${classes.headerContainer}`]: {
    maxWidth: '10rem',
    flex: 1,
  },
  [`& .${classes.appLogo}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontSize: '0.8rem',
    fontWeight: 500,
  },
  [`& .${classes.vignet}`]: {
    backgroundColor: xxllncColor.blue20,
    color: xxllncColor.blue100,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '2rem',
    width: '2rem',
    borderRadius: '0.5rem',
  },
  [`& .${classes.appName}`]: {
    color: color.white,
    fontSize: '0.8rem',
  },
}))

export default AppBar
